import * as S from './Tip.styled';
import { useWindowSize } from 'hooks/useWindowSize';
import { useEffect, useState } from 'react';
import { Colors } from 'styles/variables/colors';

type Props = {
    icon: React.FunctionComponent<
        React.SVGProps<SVGSVGElement> & {
            title?: string | undefined;
        }
    >;
    style?: React.CSSProperties;
    children: React.ReactNode;
    mt?: string;
    mb?: string;
    ml?: string;
    mr?: string;
};

const Tip = ({ icon, children, mt, mb, ml, mr, style }: Props) => {
    const Icon = icon;
    const [width, height] = useWindowSize();
    const [mobile, setMobile] = useState(false);

    useEffect(() => {
        if (width >= 769) {
            setMobile(false);
        }
        if (width < 769) {
            setMobile(true);
        }
    }, [width, height]);

    return (
        <S.Tip
            mobile={mobile}
            style={{
                marginTop: mt ? mt : '',
                marginBottom: mb ? mb : '',
                marginLeft: ml ? ml : '',
                marginRight: mr ? mr : '',
                ...style,
            }}
        >
            <div>
                <Icon fill={mobile ? Colors.gray : Colors.blue} />
            </div>
            <S.TipDesc mobile={mobile}>{children}</S.TipDesc>
        </S.Tip>
    );
};

export default Tip;
